<template>
    <div id="app">
        <div id="nav" class="noprint" v-if="token">
            <div class="maxw">
                <router-link to="/"><img src="@/assets/logo.png" height="25"></router-link>
                <div class="menu">
                    <router-link to="/serials"><barcode-icon title="Serials"></barcode-icon></router-link>
                    <router-link to="/produced"><hammer-icon title="Production"></hammer-icon></router-link>
                    <router-link to="/shipped"><ship-icon  title="Shipment"></ship-icon></router-link>
                    <router-link to="/deliverynote"><printer-icon title="Delivery Note"></printer-icon></router-link>
                    <!--<router-link to="/transfers"><transfer-icon title="Transfers"></transfer-icon></router-link>-->
                    <router-link to="/inventory"><home-plus-icon title="Inventory"></home-plus-icon></router-link>
                </div>
            </div>
        </div>
        <router-view/>
    </div>
</template>

<script>
    import Vue from 'vue';
    import {mapState} from 'vuex';
    import Toasted from 'vue-toasted';
    import LogoutIcon from "vue-material-design-icons/logout.vue"
    import ShipIcon from "vue-material-design-icons/ferry"
    import TransferIcon from "vue-material-design-icons/truck"
    import PrinterIcon from "vue-material-design-icons/printer"
    import BarcodeIcon from "vue-material-design-icons/barcode-scan"
    import HammerIcon from "vue-material-design-icons/hammer"
    import HomePlusIcon from "vue-material-design-icons/home-plus"

    Vue.use(Toasted);

    export default {
        components: {LogoutIcon,ShipIcon,TransferIcon,PrinterIcon,BarcodeIcon,HammerIcon,HomePlusIcon},
        computed: mapState(['token']),
        methods: {},
    }
</script>

<style>
    H2 { font-variant: small-caps; margin: 0; font-size: 17px; right:5px; top: 43px; position: absolute; color: green }
    @media print {
        @page {
            margin: 1cm;
            size: portrait
        }

        .noprint, .noprint * {

            display: none !important;
        }
    }

    BODY {
        margin: 55px 0 15px 0;
        background-color: #f8f8f8;
        font-size: 14px;
        overscroll-behavior: contain;
    }

    * {
        box-sizing: border-box
    }

    .c {
        text-align: center
    }
    .big {
        font-size: 170% !important;
        width: available
    }
    .megabig {
        font-size: 300%
    }

    #app {
        font-family: Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    #nav {
        position: fixed;
        background-color: #333;
        opacity: 1;
        width: 100%;
        padding: 8px 10px;
        color: #eee;
        top: 0;
        left: 0;
        box-shadow: 0 0 3px black;
        z-index: 5;

    }

    .maxw {
        max-width: 900px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .menu a.router-link-exact-active {
        background-color: green;
        color: white;
    }

    .menu A {
        color: black;
        padding: 3px 6px 2px 6px;
        background-color: #ccc;
        border-radius: 5px;
        margin: 2px 4px;
        font-size: 20px
    }

    .menu {
        border-radius: 5px
    }

    .click {
        cursor: pointer
    }

    .logout {
        border-radius: 5px;
        border: solid 1px #aaa;
        padding: 4px 6px;
        background-color: #333;
    }

    A {
        text-decoration: none;
        color: inherit
    }

    A:visited {
    }

    TABLE.vgt-table.condensed {
        font-size: 13px
    }

    .custom-class {
        line-height: 30px;
    }

    .vgt-pull-right .inp {
        width: auto !important;
        margin: 0 5px !important;
        font-size: 15px !important;
    }

    .vgt-pull-right > DIV {
        white-space: nowrap
    }

    .mainpage {
        padding: 15px;
        min-width: 200px;
    }

    .form {
        display: flex;
        clear: both;
    }

    .overlay {
        background-color: black;
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        right: 0;
        opacity: 0.4;
        z-index: 6
    }

    .loading {
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        padding-top: 50vh;
        text-align: center;
        width: 100%;
        z-index: 7
    }

    .inp {
        border: 1px solid #AAA;
        border-radius: 5px;
        color: #333;
        margin: 5px 0;
        padding: 5px;
        box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.2);
        background-color: white;
        width: 100%;
        font-size: 100%;
    }

    .inp::placeholder {
        padding: 5px;
        color: #ccc
    }

    .inp.validValue {
        border: solid 1px limegreen
    }

    .s {
        font-size: 12px;
        font-family: Verdana, sans-serif
    }

    BUTTON.inp {
        color: white;
        background-color: #555;
        border: solid 1px #666
    }

    BUTTON.inp2 {
        padding: 2px 6px
    }

    BUTTON.inp.defcolor {
        background-color: green;
    }

    BUTTON.inp:disabled {
        background-color: #ccc;
        opacity: 0.6;
        cursor: not-allowed;
        border: solid 1px #ccc
    }

    .home {
        max-width: 900px;
        margin: 0px auto 8px auto;
        padding: 8px 10px;
        position: relative;
        border: solid 1px #ccc;
        background-color: #f0f0f0;
        border-radius: 5px;
    }

    @media only screen and (max-width: 350px) {
        .home {
            padding: 8px 6px;
        }

        .mainpage {
            padding: 10px 0
        }
    }

    .toasted.toasted-primary {
        font-weight: bold !important;
        font-family: Arial;
    }
    .el-table .cell { line-height: 14px !important; }
    .el-table td { padding: 3px !important; }
    .material-design-icon.s2x > .material-design-icon__svg {
        height: 2em;
        width: 2em;
    }
    .material-design-icon.s2x {
        height: 2em;
        width: 2em;
    }

</style>
